import { render, staticRenderFns } from "./SelectTaxCalculation.vue?vue&type=template&id=f4ae5302&"
import script from "./SelectTaxCalculation.vue?vue&type=script&lang=ts&"
export * from "./SelectTaxCalculation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4ae5302')) {
      api.createRecord('f4ae5302', component.options)
    } else {
      api.reload('f4ae5302', component.options)
    }
    module.hot.accept("./SelectTaxCalculation.vue?vue&type=template&id=f4ae5302&", function () {
      api.rerender('f4ae5302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectTaxCalculation.vue"
export default component.exports